// @flow
import React from 'react';
import {addUrlParams} from "../../utils/UrlUtils";

import './LuxtrustFrame.less';

export class LuxtrustFrame extends React.Component {

   render() {
      const {url, params} = this.props;
      return (
         <iframe
            title="embed luxtrust"
            src={addUrlParams(url, params)}
            frameBorder="none"
            name={'luxtrust-iframe'}
            className={'luxtrust-iframe'}
         />
      );
   }
}

export default LuxtrustFrame;
